import { createContext } from 'react';

const PecaContext = createContext();

export default PecaContext;
